import { render, staticRenderFns } from "./skyex_shipment_tracking.vue?vue&type=template&id=95f98fa8&"
import script from "./skyex_shipment_tracking.vue?vue&type=script&lang=js&"
export * from "./skyex_shipment_tracking.vue?vue&type=script&lang=js&"
import style0 from "./skyex_shipment_tracking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports